import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { sendEmailCode, verifyEmailCode, signup } from '../../api/auth';
import { useTranslation } from 'react-i18next';

function Join() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [nickname, setNickname] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

// 이전 페이지에서 선택한 값 불러오기
const [nationalityCode, setNationalityCode] = useState(
  localStorage.getItem('selectedNationality') || ''
);
  const [schoolId, setSchoolId] = useState(() => {
    const id = localStorage.getItem('selectedSchoolId');
    console.log('init schoolId from localStorage:', id); // ← 여기
    return id ? Number(id) : null;
  });
const [isExchange, setIsExchange] = useState(
  JSON.parse(localStorage.getItem('isExchange') || 'false')
);
const [language, setLanguage] = useState(
  localStorage.getItem('language') || 'ko'
);


useEffect(() => {
  const storedNationality = localStorage.getItem('selectedNationality');
  const storedSchoolId = localStorage.getItem('selectedSchoolId');
  const storedIsExchange = JSON.parse(localStorage.getItem('isExchange') || 'false');

  if (storedNationality) setNationalityCode(storedNationality);
  if (storedSchoolId) setSchoolId(Number(storedSchoolId));
  setIsExchange(storedIsExchange);
}, []);

  const [isFormValid, setIsFormValid] = useState(false);
  useEffect(() => {
    setIsFormValid(email && code && password && nickname);
  }, [email, code, password, nickname]);
  
  // 이메일 인증번호 발송
  const handleSendCode = async (e) => {
    e.preventDefault();
    try {
      await sendEmailCode(email);
      alert('인증번호가 이메일로 발송되었습니다.');
      setEmailSent(true);
    } catch (err) {
      console.error(err);
      alert('이메일 전송 중 오류가 발생했습니다.');
    }
  };

  // 회원가입 처리
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) {
      alert('모든 필드를 입력해주세요.');
      return;
    }
    if (!nationalityCode) {
  alert('국적을 선택해주세요.');
  return;
}

    try {
      // 1. 인증번호 검증
      await verifyEmailCode(email, code);
console.log('Signup payload:', {
  email,
  password,
  nickname,
  nationalityCode,
  schoolId,
  isExchange,
  language,
});
      // 2. 회원가입 요청 (한 번에 모든 데이터 전달)
      await signup({
        email,
        password,
        nickname,
        nationalityCode,
        schoolId: Number(schoolId),
        isExchange,
        language,
      });

      alert('회원가입 성공!');
      navigate('/login');
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert('회원가입 처리 중 오류가 발생했습니다.');
    }
  };

  return (
    <div className='wrap'>
      <div className='join-wrap'>
    <div className='join-box1'>
    <a href="/joinStudent">
    <svg className='back' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.825 9L8.71247 13.8875C9.10497 14.28 9.10215 14.9172 8.70619 15.3062C8.31517 15.6904 7.68758 15.6876 7.29997 15.3L0.707106 8.70711C0.316582 8.31658 0.316583 7.68342 0.707107 7.29289L7.29997 0.700027C7.68759 0.312414 8.31517 0.309638 8.70619 0.693805C9.10215 1.08281 9.10497 1.72003 8.71247 2.11253L3.825 7H15C15.5523 7 16 7.44772 16 8C16 8.55229 15.5523 9 15 9H3.825Z" fill="#333333"/>
</svg>
</a>
</div>
<div className="join-box2">
  <h1 className='join-p1'>{t('signup.title')}</h1>
    <form className='join-form' onSubmit={handleSubmit}>
      <div className='join-email'>
          <svg className='email-svg' width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.30772 15.5C1.80259 15.5 1.37502 15.325 1.02502 14.975C0.675023 14.625 0.500023 14.1974 0.500023 13.6923V2.3077C0.500023 1.80257 0.675023 1.375 1.02502 1.025C1.37502 0.675 1.80259 0.5 2.30772 0.5H17.6923C18.1974 0.5 18.625 0.675 18.975 1.025C19.325 1.375 19.5 1.80257 19.5 2.3077V13.6923C19.5 14.1974 19.325 14.625 18.975 14.975C18.625 15.325 18.1974 15.5 17.6923 15.5H2.30772ZM10 8.55763L2 3.44225V13.6923C2 13.782 2.02885 13.8557 2.08655 13.9134C2.14425 13.9711 2.21797 14 2.30772 14H17.6923C17.782 14 17.8558 13.9711 17.9135 13.9134C17.9711 13.8557 18 13.782 18 13.6923V3.44225L10 8.55763ZM10 6.99998L17.8461 1.99998H2.15385L10 6.99998ZM2 3.44225V1.99998V13.6923C2 13.782 2.02885 13.8557 2.08655 13.9134C2.14425 13.9711 2.21797 14 2.30772 14H2V3.44225Z" fill="#888888"/>
</svg>
        <input
          placeholder={t('signup.email')}
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button onClick={handleSendCode} disabled={!email}>{t('signup.sendCode')}</button>
      </div>
      <div className='join-code'>
          <svg className='code-svg' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99998 0.596191L18.7807 5.82309C19.0038 5.96796 19.1794 6.15866 19.3076 6.39519C19.4358 6.63172 19.5 6.88332 19.5 7.14999V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H2.3077C1.80257 19.5 1.375 19.325 1.025 18.975C0.675 18.625 0.5 18.1974 0.5 17.6923V7.14999C0.5 6.88332 0.564108 6.63172 0.692325 6.39519C0.820525 6.15866 0.996158 5.96796 1.21923 5.82309L9.99998 0.596191ZM9.99998 11.65L17.8 6.99999L9.99998 2.34999L2.19998 6.99999L9.99998 11.65ZM9.99998 13.4038L1.99998 8.62302V17.6923C1.99998 17.782 2.02883 17.8557 2.08653 17.9134C2.14423 17.9711 2.21795 18 2.3077 18H17.6923C17.782 18 17.8557 17.9711 17.9134 17.9134C17.9711 17.8557 18 17.782 18 17.6923V8.62302L9.99998 13.4038Z" fill="#888888"/>
</svg>
<input
  placeholder={t('signup.code')}
  type="text"
  id="code"
  value={code}
  onChange={(e) => setCode(e.target.value)}
  required
  disabled={!emailSent}
/>
      </div>
      <div className='join-password'>
          <svg className='password-svg' width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.30772 19.5C1.80901 19.5 1.38305 19.3234 1.02985 18.9701C0.676631 18.6169 0.500023 18.191 0.500023 17.6923V8.30771C0.500023 7.80899 0.676631 7.38304 1.02985 7.02984C1.38305 6.67662 1.80901 6.50001 2.30772 6.50001H3.50002V4.50001C3.50002 3.25131 3.93784 2.18915 4.81347 1.31351C5.68912 0.437878 6.7513 6.10352e-05 8 6.10352e-05C9.2487 6.10352e-05 10.3109 0.437878 11.1865 1.31351C12.0622 2.18915 12.5 3.25131 12.5 4.50001V6.50001H13.6923C14.191 6.50001 14.6169 6.67662 14.9701 7.02984C15.3234 7.38304 15.5 7.80899 15.5 8.30771V17.6923C15.5 18.191 15.3234 18.6169 14.9701 18.9701C14.6169 19.3234 14.191 19.5 13.6923 19.5H2.30772ZM2.30772 18H13.6923C13.782 18 13.8557 17.9711 13.9134 17.9134C13.9711 17.8557 14 17.782 14 17.6923V8.30771C14 8.21796 13.9711 8.14424 13.9134 8.08654C13.8557 8.02884 13.782 7.99999 13.6923 7.99999H2.30772C2.21797 7.99999 2.14425 8.02884 2.08655 8.08654C2.02885 8.14424 2 8.21796 2 8.30771V17.6923C2 17.782 2.02885 17.8557 2.08655 17.9134C2.14425 17.9711 2.21797 18 2.30772 18ZM8 14.75C8.4859 14.75 8.89903 14.5798 9.2394 14.2394C9.57978 13.899 9.74997 13.4859 9.74997 13C9.74997 12.5141 9.57978 12.101 9.2394 11.7606C8.89903 11.4202 8.4859 11.25 8 11.25C7.5141 11.25 7.10097 11.4202 6.7606 11.7606C6.42021 12.101 6.25002 12.5141 6.25002 13C6.25002 13.4859 6.42021 13.899 6.7606 14.2394C7.10097 14.5798 7.5141 14.75 8 14.75ZM5 6.50001H11V4.50001C11 3.66668 10.7083 2.95834 10.125 2.37501C9.54167 1.79168 8.83333 1.50001 8 1.50001C7.16666 1.50001 6.45833 1.79168 5.875 2.37501C5.29166 2.95834 5 3.66668 5 4.50001V6.50001Z" fill="#888888"/>
</svg>
        <input
          placeholder={t('signup.password')}
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <div className="join-nickname">
       <svg className='nickname-svg' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.02308 15.2923C4.87308 14.6615 5.79903 14.1635 6.80095 13.7981C7.80287 13.4327 8.86921 13.25 9.99998 13.25C11.1307 13.25 12.1971 13.4327 13.199 13.7981C14.2009 14.1635 15.1269 14.6615 15.9769 15.2923C16.5987 14.609 17.0913 13.8179 17.4548 12.9192C17.8182 12.0205 18 11.0474 18 9.99998C18 7.78331 17.2208 5.89581 15.6625 4.33748C14.1041 2.77914 12.2166 1.99998 9.99998 1.99998C7.78331 1.99998 5.89581 2.77914 4.33748 4.33748C2.77914 5.89581 1.99998 7.78331 1.99998 9.99998C1.99998 11.0474 2.18171 12.0205 2.54518 12.9192C2.90864 13.8179 3.40128 14.609 4.02308 15.2923ZM10.0003 10.75C9.08726 10.75 8.31729 10.4366 7.69038 9.80988C7.06346 9.18314 6.75 8.41328 6.75 7.50028C6.75 6.58726 7.06336 5.81729 7.69008 5.19038C8.31681 4.56346 9.08668 4.25 9.99968 4.25C10.9127 4.25 11.6827 4.56336 12.3096 5.19008C12.9365 5.81681 13.25 6.58668 13.25 7.49968C13.25 8.41269 12.9366 9.18266 12.3099 9.80958C11.6831 10.4365 10.9133 10.75 10.0003 10.75ZM9.99998 19.5C8.68074 19.5 7.44325 19.2519 6.2875 18.7557C5.13173 18.2596 4.12628 17.5839 3.27115 16.7288C2.41603 15.8737 1.7404 14.8682 1.24425 13.7125C0.748083 12.5567 0.5 11.3192 0.5 9.99998C0.5 8.68074 0.748083 7.44325 1.24425 6.2875C1.7404 5.13173 2.41603 4.12628 3.27115 3.27115C4.12628 2.41603 5.13173 1.7404 6.2875 1.24425C7.44325 0.748084 8.68074 0.5 9.99998 0.5C11.3192 0.5 12.5567 0.748084 13.7125 1.24425C14.8682 1.7404 15.8737 2.41603 16.7288 3.27115C17.5839 4.12628 18.2596 5.13173 18.7557 6.2875C19.2519 7.44325 19.5 8.68074 19.5 9.99998C19.5 11.3192 19.2519 12.5567 18.7557 13.7125C18.2596 14.8682 17.5839 15.8737 16.7288 16.7288C15.8737 17.5839 14.8682 18.2596 13.7125 18.7557C12.5567 19.2519 11.3192 19.5 9.99998 19.5ZM9.99998 18C10.9025 18 11.7727 17.8548 12.6105 17.5644C13.4484 17.274 14.1923 16.8679 14.8423 16.3461C14.1923 15.8436 13.458 15.4519 12.6394 15.1711C11.8208 14.8903 10.941 14.75 9.99998 14.75C9.05894 14.75 8.17753 14.8887 7.35573 15.1663C6.53393 15.4439 5.80123 15.8371 5.15765 16.3461C5.80765 16.8679 6.55157 17.274 7.3894 17.5644C8.22722 17.8548 9.09741 18 9.99998 18ZM9.99998 9.25C10.4974 9.25 10.9134 9.08269 11.2481 8.74808C11.5827 8.41344 11.75 7.99741 11.75 7.49998C11.75 7.00254 11.5827 6.58651 11.2481 6.25188C10.9134 5.91726 10.4974 5.74995 9.99998 5.74995C9.50254 5.74995 9.08651 5.91726 8.75187 6.25188C8.41726 6.58651 8.24995 7.00254 8.24995 7.49998C8.24995 7.99741 8.41726 8.41344 8.75187 8.74808C9.08651 9.08269 9.50254 9.25 9.99998 9.25Z" fill="#888888"/>
</svg> 
      <input
  placeholder={t('signup.nickname')}
  type="text"
  id="nickname"
  value={nickname}
  onChange={(e) => setNickname(e.target.value)}
  required
/> 
      </div>
      <button 
      className={`join-button ${isFormValid ? 'active' : ''}`}
      type="submit"
      disabled={!isFormValid}>
        {t('signup.button')}
      </button>
    </form>
  </div>      
  </div>
    </div>
  )
}

export default Join